export default "__VITE_ASSET__Dr8Q1m5A__"